export default __webpack_public_path__ + "static/media/limb_big@2x.5a276dc4.jpg";